import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Hamburger = ({
  id = '',
  className = '',
  style = {},
  opened,
  onMenuClick = () => {},
}) => {
  const hamburgerContainerClass = classNames(
    'flex flex-col justify-center items-center cursor-pointer',
    className,
  );

  const barClass = 'w-6 h-0.5 bg-white mb-1 last:mb-0 transition-transform duration-500';

  const bar1Class = classNames(barClass, {
    'transform rotate-45 translate-y-2': opened,
    'mt-1': true
  });

  const bar2Class = classNames(barClass, {
    'opacity-0': opened,
  });

  const bar3Class = classNames(barClass, {
    'transform -rotate-45 -translate-y-1': opened,
  });

  return (
    <div
      id={id}
      className={hamburgerContainerClass}
      onClick={onMenuClick}
      role="button"
      tabIndex={0}
      style={style}
      aria-label='Menu'
      aria-expanded={opened}
    >
      <div className={bar1Class} />
      <div className={bar2Class} />
      <div className={bar3Class} />
    </div>
  );
};

Hamburger.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  opened: PropTypes.bool,
  onMenuClick: PropTypes.func,
};

Hamburger.defaultProps = {
  id: '',
  className: '',
  style: {},
  opened: false,
  onMenuClick: () => {},
};

export default Hamburger;
